<!--<div #gridWrapper [style.height.px]="dashboardHeight">-->
<div #gridWrapper class="flex flex-col grow">
  <gridster [options]="options" [class.surface-ground]="!devMode">
    @if (formattedDashboardItems$ | async; as formattedDashboardItems) {
      @for (item of formattedDashboardItems; track $index) {
        <gridster-item [item]="item.gridData" class="max-w-full">
          <ng-template [ngTemplateOutlet]="widget" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
        </gridster-item>
      }
    }
  </gridster>
</div>
